module.exports = __webpack_public_path__ + "img/banner_2.c4227dbe.png";